import { z } from 'zod';

// On-demand per-user expiry summary for the profile "N points expire on {date}" line.
// Served by GET /api/v2/point_expiry/users/:id, keys camelized by OliveBranch because the
// query sends `Key-Inflection: camel`. Both fields are null when there is nothing to show
// (feature off, no live period, or an unknown/foreign-company id); `.catch(undefined)` keeps a
// malformed value from throwing so the profile page degrades to simply hiding the line.
export const PointExpiryForUser = z.object({
	expiringPoints: z.number().nullable().optional().catch(undefined),
	expiresOn: z.string().nullable().optional().catch(undefined),
});
export type PointExpiryForUser = z.infer<typeof PointExpiryForUser>;
